import api from "./api";

export const getCourts = async (params) => {
  return api
    .get({
      endpoint: "/own/court/list",
      port: process.env.REACT_APP_PORT_COURT,
      queryParam: params,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
